import React from "react";

export default function OfferzPlusSvg(): React.JSX.Element {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      fill="#000000"
      height="24"
      width="24"
    >
      <circle cx="100" cy="100" r="92" fill="none" stroke="#000000" stroke-width="4" />

      <g transform="translate(46, 64) scale(0.88)">
        <path d="M0,14.4v21.4h70.2L59.1,24.7l6.9-6.9L77.1,29V0.1H14.3C6.4,0.1,0,6.5,0,14.4z" />
        <path d="M108.4,0.1H86.8V29L98,17.9l6.9,6.9L93.7,35.8h29V14.4C122.7,6.5,116.3,0.1,108.4,0.1z" />
        <path d="M104.8,56.7L98,63.6L86.8,52.4v28.9h21.5c7.9,0,14.3-6.4,14.3-14.3V45.6h-29L104.8,56.7z" />
        <path d="M59.1,56.7l11.1-11.1H0V67c0,7.9,6.4,14.3,14.3,14.3h62.8V52.4L66,63.6L59.1,56.7z" />
      </g>
    </svg>
  );
}
